import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import { formatDocumentTitle } from './utils/seo'

import axios from 'axios'
import VueAxios from 'vue-axios'

createInertiaApp({
    progress: {
        delay: 100,
        color: '#3c4858',
        includeCSS: true,
        showSpinner: true,
    },
    resolve: name => require(`./Pages/${name}`),
    title: title => formatDocumentTitle(title),
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .mixin({ methods: { route : route } })
            .mixin(require('./base'))
            .use(plugin)
            .use(VueAxios, axios)
            .mount(el)
    },
})
